import {
	Container,
	TextAlignment,
	TokenTextAppearance,
	TokenTextColor,
	Text,
	ContainerGutter,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import styled from 'styled-components';
import { HuchaLogo } from '../../../asserts/hucha-logo';

const MainContainer = styled(Container)`
	padding: 0px;
	align-content: center;

	/* Mobile & Tablet */
	@media (min-width: 1599px) {
		height: fit-content;
	}

	/* Desktop */
	@media (min-width: 960px) {
		padding-right: var(--size-dynamic0100);
		height: 193px;
	}
`;

const TextWrapper = styled.div`
	display: block;
	/* ocultar para desktop */
	@media (min-width: 1600px) {
		display: none;
	}
`;

export const HuchaBonusCardC1 = () => {
	return (
		<MainContainer data-testid="c1-container" gutter={ContainerGutter.static300} wrap="always">
			<HuchaLogo />
			<TextWrapper>
				<Text
					appearance={TokenTextAppearance.headline100}
					color={TokenTextColor.inverted}
					textAlign={TextAlignment.left}
					bold
				>
					{'Cada mes, acumulas 10€ para tu próximo Volkswagen'}
				</Text>
			</TextWrapper>
		</MainContainer>
	);
};
